import { get, postWithToast } from '../../utils/fetch';
import * as Types from './disciplines.types';
import { ItemsEntity } from 'typings/pagination';
import { OptionsGenerator } from 'ui/Select/Select.types';
import { disciplineTypes } from 'messages/ru';

export const getOrganizationDisciplines = () =>
    get<ItemsEntity<Types.DisciplineInfo>>(`Discipline/GetDisciplines`).then(
        ({ items }) => items
    );

export const getOrganizationDisciplinesOptions: OptionsGenerator<
    typeof getOrganizationDisciplines,
    number
> = () =>
    getOrganizationDisciplines().then((items) =>
        items.map((item) => ({
            value: item.id,
            data: item,
            label:
                item.title +
                (item.type && ` (${disciplineTypes[item.type]})`) +
                (item.hoursCount && ` (${item.hoursCount} ч.)`)
        }))
    );

export const createDiscipline = (props: Types.CreateDisciplineFormData) =>
    postWithToast<
        unknown,
        Types.DisciplineInfo,
        Types.CreateDisciplineFormData
    >('Discipline/AddDiscipline', props);
